/* eslint-disable prefer-destructuring */
import {destandard, getPaginationFromMeta} from '../utils/commonFunctions';

export const GET_USER_ACCESS_TOKENS_FULFILLED = 'GET_USER_ACCESS_TOKENS_FULFILLED';
export const GET_USER_ACCESS_TOKENS_PENDING = 'GET_USER_ACCESS_TOKENS_PENDING';
export const GET_USER_ACCESS_TOKENS_REJECTED = 'GET_USER_ACCESS_TOKENS_REJECTED';

export const GET_USER_ACCESS_TOKEN_FULFILLED = 'GET_USER_ACCESS_TOKEN_FULFILLED';
export const GET_USER_ACCESS_TOKEN_PENDING = 'GET_USER_ACCESS_TOKEN_PENDING';
export const GET_USER_ACCESS_TOKEN_REJECTED = 'GET_USER_ACCESS_TOKEN_REJECTED';

export const POST_USER_ACCESS_TOKEN_FULFILLED = 'POST_USER_ACCESS_TOKEN_FULFILLED';
export const POST_USER_ACCESS_TOKEN_PENDING = 'POST_USER_ACCESS_TOKEN_PENDING';
export const POST_USER_ACCESS_TOKEN_REJECTED = 'POST_USER_ACCESS_TOKEN_REJECTED';

const initialState = {
  userAccessTokens: [],
  userAccessToken: {},
  paging: {
    number: 1,
    size: 20,
  },
  fetching: false,
  fetched: false,
};

const applyLoadingState = state => ({
  ...state,
  fetching: true,
  fetched: false,
});

const applyUserTokensFulfilled = (state, payLoad) => ({
  ...state,
  fetching: false,
  fetched: true,
  userAccessTokens: payLoad.data,
  paging: getPaginationFromMeta(initialState.paging, state.paging, payLoad.links.last)
});

const applyUserTokenFulfilled = (state, payLoad) => ({
  ...state,
  fetching: false,
  fetched: true,
  userAccessToken: destandard(payLoad.data.attributes),
});

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_ACCESS_TOKEN_PENDING:
    case GET_USER_ACCESS_TOKENS_PENDING: {
      return applyLoadingState(state);
    }
    case GET_USER_ACCESS_TOKENS_FULFILLED: {
      return applyUserTokensFulfilled(state, action.payLoad);
    }
    case GET_USER_ACCESS_TOKEN_FULFILLED: {
      return applyUserTokenFulfilled(state, action.payLoad);
    }
    case POST_USER_ACCESS_TOKEN_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
      };
    }
    case GET_USER_ACCESS_TOKENS_REJECTED: {
      return {
        ...state,
        errors: action.payLoad
      };
    }
    default:
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/reducers/accessTokenReducer.js